export default "__VITE_ASSET__C0asx9OU__"